import { Bug } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface Props {
  className?: string;
}

export default function BugReportBadge({ className = '' }: Props) {
  const { t } = useTranslation();
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium
                  bg-danger-100 text-danger-700 ${className}`}
      title={t('bugReport.badge')}
    >
      <Bug size={12} />
      {t('bugReport.badge')}
    </span>
  );
}
